module.exports = __webpack_public_path__ + "static/media/emasdesa.845edf7d.png";